"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.hasLinks ? _c('div', {
    class: ['kiwi-social-links', _vm.layoutClass]
  }, [_vm.trimmed.instagram ? _c('a', {
    staticClass: "kiwi-social-link",
    attrs: {
      "href": _vm.trimmed.instagram,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "title": "Instagram",
      "aria-label": "Instagram"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm.trimmed.twitter ? _c('a', {
    staticClass: "kiwi-social-link",
    attrs: {
      "href": _vm.trimmed.twitter,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "title": "X (Twitter)",
      "aria-label": "X (Twitter)"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm.trimmed.facebook ? _c('a', {
    staticClass: "kiwi-social-link",
    attrs: {
      "href": _vm.trimmed.facebook,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "title": "Facebook",
      "aria-label": "Facebook"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-official",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm.trimmed.tiktok ? _c('a', {
    staticClass: "kiwi-social-link kiwi-social-link--tiktok",
    attrs: {
      "href": _vm.trimmed.tiktok,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "title": "TikTok",
      "aria-label": "TikTok"
    }
  }, [_c('svg', {
    staticClass: "kiwi-social-tiktok-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "aria-hidden": "true",
      "focusable": "false"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"
    }
  })])]) : _vm._e(), _vm.trimmed.telegram ? _c('a', {
    staticClass: "kiwi-social-link",
    attrs: {
      "href": _vm.trimmed.telegram,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "title": "Telegram",
      "aria-label": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fa fa-telegram",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm.trimmed.reddit ? _c('a', {
    staticClass: "kiwi-social-link",
    attrs: {
      "href": _vm.trimmed.reddit,
      "target": "_blank",
      "rel": "noopener noreferrer",
      "title": "Reddit",
      "aria-label": "Reddit"
    }
  }, [_c('i', {
    staticClass: "fa fa-reddit",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]) : _vm._e();
};
var staticRenderFns = exports.staticRenderFns = [];